import { z } from 'zod'
import { required } from '@portal/pkg-hook-form'
import { LicenseType, IntegrationRoleOption, NotificationFrequencyOption } from './addUserSchema'

export { LicenseType, IntegrationRoleOption, NotificationFrequencyOption }

export const EditUserSchema = z.object({
  firstName: z.string().superRefine(required()),
  lastName: z.string().superRefine(required()),
  email: z.string(),
  licenseType: z.nativeEnum(LicenseType),
  integrationsRole: z.string(),
  projectParticipant: z.boolean(),
  emailNotifications: z.boolean(),
  notificationFrequency: z.string(),
})

export type EditUserFormValues = z.infer<typeof EditUserSchema>
